const RoundSeperator = ({ roundIndex }: { roundIndex: number }) => (
  <div className="roundsGraph__roundSeperator">
    <div className="roundsGraph__roundSeperator__verticalLine">
      <p>R{roundIndex + 1}</p>
    </div>
  </div>
)

export default RoundSeperator
